import {call, put, select} from "redux-saga/effects";
import {commentAutosuggestSearchSelector} from "features/components/comment-field/comment-autosuggest/selectors";
import * as api from "services/api";
import {
    autosuggestCommentFailure,
    autosuggestCommentSuccess
} from "features/components/comment-field/comment-autosuggest/reducer";
import {getErrorFromMessage} from "services/utils/utils";

export function* autosuggestCommentTagSaga() {
    const search = yield select(commentAutosuggestSearchSelector);
    if(!!search) {
        try {
            const data = yield call([api, api.searchUsers], search);
            yield put(autosuggestCommentSuccess(data));
        } catch (e) {
            yield put(autosuggestCommentFailure(getErrorFromMessage(e)));
        }
    }
}